export default {
  list: [
    {
      title: 'ثبت موقت',
      value: 'TEMPORARY_SAVE'
    },
    {
      title: 'ثبت نهایی',
      value: 'FINAL_SAVE'
    },
    {
      title: 'انصراف',
      value: 'CANCEL'
    }
  ],
  values: {
    TEMPORARY_SAVE: 'TEMPORARY_SAVE',
    FINAL_SAVE: 'FINAL_SAVE',
    CANCEL: 'CANCEL'
  }
};
